
import { DependencyLifeTime, Injectable } from "@miracledevs/paradigm-web-di";
import { ContextCollection } from "../../../contexts/DependencyContext";
import { MeasuresApiClient } from "../clients/MeasuresApiClient";
import { IMeasure } from "./models/IMeasure";
import { IGetDataSourceMeasuresParameters } from "./models/IGetDataSourceMeasuresParameters";
import { IMeasurePeriod } from "./models/IMeasurePeriod";
import { IGetDataSourceMeasureHistoryByPointsParameters } from "./models/IGetDataSourceMeasureHistoryByPointsParameters";
import { INumericTimeSeriesPoints } from "./models/INumericTimeSeriesPoints";
import { IMeasureSummary } from "./models/IMeasureSummary";
import { IGetDataSourceMeasureSummaryParameters } from "./models/IGetDataSourceMeasureSummaryParameters";

@Injectable({ collection: ContextCollection, lifeTime: DependencyLifeTime.Singleton })
export class MeasureService
{
	private readonly url: string;

	constructor(private readonly apiClient: MeasuresApiClient)
    {
        this.url = "measure";
    }

    async getDataSourceMeasureHistory(parameters: IGetDataSourceMeasuresParameters): Promise<IMeasure[]>
    {
        return await this.apiClient.post<IMeasure[]>(`${this.url}/datasource`,{},JSON.stringify(parameters));
    }

    async getDataSourceMeasureHistoryByPoints(parameters: IGetDataSourceMeasureHistoryByPointsParameters): Promise<IMeasurePeriod>
    {
        return await this.apiClient.post<IMeasurePeriod>(`${this.url}/points`,{},JSON.stringify(parameters));
    }

    async getNumericTimeSeriesPoints(parameters: IGetDataSourceMeasureHistoryByPointsParameters): Promise<INumericTimeSeriesPoints>
    {
        return await this.apiClient.post<INumericTimeSeriesPoints>(`${this.url}/timeseries`,{},JSON.stringify(parameters));
    }

    async getDataSourceMeasureSummary(parameters: IGetDataSourceMeasureSummaryParameters): Promise<IMeasureSummary>
    {
        return await this.apiClient.post<IMeasureSummary>(`${this.url}/summary`,{},JSON.stringify(parameters));
    }

    async hasMeasuresSince(parameters: IGetDataSourceMeasuresParameters): Promise<boolean>
    {
        return await this.apiClient.post<boolean>(`${this.url}/hasmeasuressince`,{},JSON.stringify(parameters));
    }

    async getDataSourceCurrentValue(parameters: IGetDataSourceMeasuresParameters): Promise<number>
    {
        return await this.apiClient.post<number>(`${this.url}/currentvalue`,{},JSON.stringify(parameters));
    }

    async add(measure: IMeasure): Promise<void>
    {
        this.apiClient.post(`${this.url}/save`,{},JSON.stringify(measure));
    }

    async addBatch(measures: IMeasure[]): Promise<void>
    {
        this.apiClient.post(`${this.url}/add/batch`,{},JSON.stringify(measures));
    }

    async addInParallel(measures: IMeasure[]): Promise<void>
    {
        this.apiClient.post(`${this.url}/add/parallel`,{},JSON.stringify(measures));
    }

    async getNumericTimeSeriesLargePoints(dataSourceId: number): Promise<INumericTimeSeriesPoints>
    {
        return await this.apiClient.get<INumericTimeSeriesPoints>(`${this.url}/timeseries/byday/large/${dataSourceId}`);
    }

    async getNumericTimeSeriesSmallPoints(dataSourceId: number): Promise<INumericTimeSeriesPoints>
    {
        return await this.apiClient.get<INumericTimeSeriesPoints>(`${this.url}/timeseries/byday/small/${dataSourceId}`);
    }
}
